module.exports = __webpack_public_path__ + "static/media/roble_california.a71384e6.jpg";